import React, {useEffect, useState} from 'react';
import * as blockConstants from '../constants';
import {blockButtonsModel, blockCalendarModel, blockTypeOptions} from '../models';
import {
    ControlLabel,
    Modal,
    FormControl,
    FormGroup,
    Button,
    Row,
    Col,
    Checkbox,
} from 'react-bootstrap';
import RichEditor from '../../../RichEditor';
import BlockButtonFields from './BlockButtonFields';

import './block-edit-modal.scss';
import {ucFirst} from "../../../../../admin/js/lib";

const globalPlaceholders = [
    "eventName",
    "timeStart",
    "timeStop",
    "dateStart",
    "dateStop",
    "datetimeStart",
    "datetimeStop",
    "userEmail",
];

const BlocksEditModal = ({isModalVisible, editableModel, event, onHide, onSave}) => {
    const [model, setModel] = useState(null);
    const [activitiesModel, setActivitiesModel] = useState(blockCalendarModel);

    useEffect(() => {
        setModel(editableModel);
        setActivitiesModel(editableModel?.activities?.[0] ?? blockCalendarModel);
    }, []);

    useEffect(() => {
        setModel((prev) => {
            return {
                ...prev,
                [blockConstants.BLOCK_ACTIVITIES]: [activitiesModel],
            }
        });
    }, [activitiesModel])

    function handleModelChange(key, value) {
        setModel((prev) => {
            return {...prev,
            [key]: value,}
        });
    }

    function handleUpdateButton(buttonModel, index) {
        setModel({
            ...model,
            [blockConstants.BLOCK_BUTTONS]: model[blockConstants.BLOCK_BUTTONS].map((model, i) => {
                if (i === index) return buttonModel;

                return model;
            }),
        });
    }

    function hanldeAddButton() {
        setModel({
            ...model,
            buttons: [...model.buttons, blockButtonsModel],
        });
    }

    function handleRemoveButton(index) {
        setModel({
            ...model,
            [blockConstants.BLOCK_BUTTONS]: model[blockConstants.BLOCK_BUTTONS].filter((_, i) => i !== index),
        });
    }

    function handleSubmit(e) {
        e.preventDefault();
        onSave(model, !!editableModel.id);
    }

    function removeTabIndex(dialog) {
        dialog.removeAttribute('tabindex');
    }

    const placeholders = [
        ...globalPlaceholders,
        'userName',
        ...event.registrationFields.map(({field}) => 'user' + ucFirst(field.name)),
    ]

    return (
        !!model &&
        <Modal
            show={isModalVisible}
            bsSize="large"
            backdrop="static"
            className="block-edit-modal"
            onHide={() => onHide()}
            onEntered={removeTabIndex}
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    {!!model.id ? 'Редактирование блока' : 'Новый блок'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form id="edit-block-form" onSubmit={(e) => handleSubmit(e)}>
                    <Row>
                        <Col xs={12}>
                            <FormGroup controlId={blockConstants.BLOCK_NAME}>
                                <ControlLabel>
                                    Имя блока
                                </ControlLabel>
                                <FormControl
                                    value={model[blockConstants.BLOCK_NAME]}
                                    type="text"
                                    placeholder="Введите имя блока"
                                    required
                                    onChange={(e) => handleModelChange(blockConstants.BLOCK_NAME, e.target.value)}
                                />
                            </FormGroup>
                        </Col>
                        {/* <Col xs={6}>
                            <FormGroup controlId={blockConstants.BLOCK_TYPE}>
                                <ControlLabel>
                                    Тип блока
                                </ControlLabel>
                                <FormControl
                                    value={model[blockConstants.BLOCK_TYPE]}
                                    componentClass="select"
                                    onChange={(e) => handleModelChange(blockConstants.BLOCK_TYPE, e.target.value)}
                                >
                                    {
                                        Object.entries(blockTypeOptions).map(([key, name]) => (
                                            <option
                                                key={key}
                                                value={key}
                                            >
                                                {name}
                                            </option>
                                        ))
                                    }
                                </FormControl>
                            </FormGroup>
                        </Col> */}
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <FormGroup controlId={blockConstants.BLOCK_DESCRIPTION}>
                                <ControlLabel>
                                    Описание блока
                                </ControlLabel>
                                <FormControl
                                    value={model[blockConstants.BLOCK_DESCRIPTION]}
                                    componentClass="textarea"
                                    placeholder="Описание блока"
                                    onChange={(e) => handleModelChange(blockConstants.BLOCK_DESCRIPTION, e.target.value)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    {
                        model.type !== blockConstants.BLOCK_TYPE_DISCLAIMER &&
                        <Row>
                            <Col xs={12}>
                                <FormGroup>
                                    <Checkbox
                                        checked={model[blockConstants.BLOCK_SHOW_TITLE]}
                                        onChange={(e) => handleModelChange(blockConstants.BLOCK_SHOW_TITLE, e.target.checked)}
                                    >
                                        Показывать заголовок
                                    </Checkbox>
                                </FormGroup>
                            </Col>
                            <Col xs={6}>
                                <FormGroup controlId={blockConstants.BLOCK_TITLE_RU}>
                                    <ControlLabel>
                                        Заголовок [Ru]
                                    </ControlLabel>
                                    <FormControl
                                        value={model[blockConstants.BLOCK_TITLE_RU]}
                                        onChange={(e) => handleModelChange(blockConstants.BLOCK_TITLE_RU, e.target.value)}
                                    />
                                </FormGroup>
                            </Col>
                            <Col xs={6}>
                                <FormGroup controlId={blockConstants.BLOCK_TITLE_EN}>
                                    <ControlLabel>
                                        Заголовок [En]
                                    </ControlLabel>
                                    <FormControl
                                        value={model[blockConstants.BLOCK_TITLE_EN]}
                                        onChange={(e) => handleModelChange(blockConstants.BLOCK_TITLE_EN, e.target.value)}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    }
                    <br />
                    <Row>
                        <Col xs={6}>
                            <ControlLabel>
                                Текст [Ru]
                            </ControlLabel>
                            <RichEditor
                                value={model[blockConstants.BLOCK_DESCRIPTION_RU]}
                                onChange={(e) => handleModelChange(blockConstants.BLOCK_DESCRIPTION_RU, e.editor.getData())}
                            />
                        </Col>
                        <Col xs={6}>
                            <ControlLabel>
                                Текст [En]
                            </ControlLabel>
                            <RichEditor
                                value={model[blockConstants.BLOCK_DESCRIPTION_EN]}
                                onChange={(e) => handleModelChange(blockConstants.BLOCK_DESCRIPTION_EN, e.editor.getData())}
                            />
                        </Col>
                        <Col xs={12}>
                            <p>
                                <i>
                                Доступные значения: {placeholders.map(name => `{{${name}}}`).join(', ')}
                                </i>
                            </p>
                        </Col>
                    </Row>
                    {
                        (model.type !== blockConstants.BLOCK_TYPE_DISCLAIMER
                            && model.type !== blockConstants.BLOCK_TYPE_CALENDAR_OFFLINE
                            && model.type !== blockConstants.BLOCK_TYPE_CALENDAR_ONLINE
                            && model.type !== blockConstants.BLOCK_TYPE_QRCODE_OFFLINE) &&
                        <>
                            <br />
                            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                <h3>
                                    Кнопки
                                </h3>
                                <Button
                                    onClick={hanldeAddButton}
                                    disabled={model[blockConstants.BLOCK_BUTTONS].length === 2}
                                >
                                    Добавить кнопку
                                </Button>
                            </div>
                            {/* <Row>
                                {event.moduleAuth.allowLoginWithToken}
                            </Row> */}
                            {
                                model[blockConstants.BLOCK_BUTTONS].map((buttonModel, index) => (
                                    <BlockButtonFields
                                        key={index}
                                        model={buttonModel}
                                        event={event}
                                        onChange={(e) => handleUpdateButton(e, index)}
                                        onRemove={() => handleRemoveButton(index)}
                                    />
                                ))
                            }
                        </>
                    }
                    {
                        model.type === blockConstants.BLOCK_TYPE_CALENDAR_ONLINE &&
                        <Row>
                            <Col xs={12}>
                                <FormGroup>
                                    <Checkbox
                                        checked={model[blockConstants.BLOCK_ACTIVITIES][0][blockConstants.BLOCK_ACTIVITIES_PLATFORM_LINK_ONLINE]}
                                        onChange={(e) => {
                                            setActivitiesModel((prev) => ({...prev, [blockConstants.BLOCK_ACTIVITIES_PLATFORM_LINK_ONLINE]: e.target.checked}))
                                        }}
                                    >
                                        Добавить в календарь ссылку на платформу для онлайн участника
                                    </Checkbox>
                                </FormGroup>
                            </Col>
                        </Row>
                    }
                    {
                        model.type === blockConstants.BLOCK_TYPE_CALENDAR_OFFLINE &&
                        <Row>
                            <Col xs={12}>
                                <FormGroup>
                                    <Checkbox
                                        checked={model[blockConstants.BLOCK_ACTIVITIES][0][blockConstants.BLOCK_ACTIVITIES_PLATFORM_LINK_OFFLINE]}
                                        onChange={(e) => {
                                            setActivitiesModel((prev) => ({...prev, [blockConstants.BLOCK_ACTIVITIES_PLATFORM_LINK_OFFLINE]: e.target.checked}))
                                        }}
                                    >
                                        Добавить в календарь ссылку на платформу для офлайн участника
                                    </Checkbox>
                                </FormGroup>
                                <FormGroup>
                                    <ControlLabel>
                                        Добавить адрес мероприятия
                                    </ControlLabel>
                                    <FormControl
                                        value={model[blockConstants.BLOCK_ACTIVITIES][0][blockConstants.BLOCK_ACTIVITIES_EVENT_ADDRESS]}
                                        type="text"
                                        placeholder="Введите адрес"
                                        onChange={(e) => {
                                            setActivitiesModel((prev) => ({...prev, [blockConstants.BLOCK_ACTIVITIES_EVENT_ADDRESS]: e.target.value}))
                                        }}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    }
                </form>
            </Modal.Body>
            <Modal.Footer>
                <Button type="submit" form="edit-block-form">
                    Сохранить
                </Button>
                <Button onClick={() => onHide()}>
                    Отмена
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default BlocksEditModal;
